import './UniWidgetCardGraph.scss';
import { faComments } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Chart from "react-google-charts";

type UniWidgetCardGraphProps = {
    title: string,
    title1: string,
    title2: string,
    subtitle: string,
    color1?: string,
    color2?: string,
    caculatePercent?: boolean,
    value1?: number,
    value2?: number,
    value3?: number,
    percent1?: number,
    percent2?: number,
}
const UniWidgetCardGraph = ({value1, value2, value3, title1, title2, subtitle, color1, color2, title, caculatePercent, percent1, percent2}: UniWidgetCardGraphProps) => {
    return (
        <div className='card-graph'>
            <div className='card-graph-title'>{title}</div>
            <div className='d-flex justify-content-between mt-2'>
                <div style={{minWidth: '65%'}}>
                    <div className='card-graph-full-body d-flex row justify-content-between'>
                        <div className='card-graph-body col-xl-6'>
                            <span>{title1}</span>
                            <p className='body-item'>{value1} <span style={{color: color1 ?? '#1BC76D'}}>{percent1}%</span></p>
                        </div>
                        <div className='card-graph-body col-xl-6'>
                            <span>{title2}</span>
                            <p className='body-item'>{value2} <span style={{color: color2 ?? '#FF6636'}}>{percent2}%</span></p>
                        </div>
                    </div>
                    <div className='body-total mt-3 d-flex align-items-center gap-3'>
                        <FontAwesomeIcon icon={faComments} />       
                        <p>{subtitle} <span>{value3}</span></p>
                    </div>
                </div>
                <div className="card-graph-chart">
                    <Chart
                        width="100%"
                        chartType="PieChart"
                        data={[
                            ["", ""],
                            [`No prazo`, value1 ?? 0],
                            [`Atrasado`, value2 ?? 0],
                        ]}
                        legendToggle={false}
                        legend_toggle={false}
                        height={'100%'}
                        options={{
                            pieHole: 0.55,
                            is3D: false,
                            legend: 'none',
                            backgroundColor: 'transparent',
                            colors: [color1 ?? `#1BC76D`, color2 ?? `#FF6636`],
                            tooltip: {
                                enableInteractivity: false,
                                isHtml: false,
                                trigger: 'selection'
                            },
                            pieSliceText: 'none',
                        }}
                    />
                </div>
            </div>
        </div>
    )
}

export default UniWidgetCardGraph;